/* Lolly compact sticky header, progressive enhancement. */
(function () {
  'use strict';
  var root=document.documentElement;
  var header=document.getElementById('shopify-section-header') || document.querySelector('.shopify-section__header') || document.querySelector('[data-section-type="header"]')?.closest('.shopify-section');
  if (!header) return;
  var pending=false;
  function measure(){
    var size=header.getBoundingClientRect().height;
    if (size > 0) root.style.setProperty('--lolly-header-height',Math.ceil(size)+'px');
  }
  function sync(){
    pending=false;
    var compact=root.classList.contains('lolly-scrolled') ? window.scrollY>48 : window.scrollY>160; // hysteresis prevents rail-height scroll jitter
    var changed=root.classList.contains('lolly-scrolled')!==compact;
    if(changed) root.classList.toggle('lolly-scrolled',compact);
    measure();
    if(changed) window.requestAnimationFrame(measure);
  }
  function schedule(){
    if(!pending){pending=true;window.requestAnimationFrame(sync);}
  }
  window.addEventListener('scroll',schedule,{passive:true});
  window.addEventListener('resize',schedule,{passive:true});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',schedule,{once:true});
  else schedule();
})();


/* Lolly mega navigation controller — pointer hover intent and keyboard/touch. */
(function(){
 'use strict';
 var root=document.querySelector('.lolly-mega-rail');
 if(!root)return;
 var items=[].slice.call(root.querySelectorAll('[data-lolly-mega-item]'));
 var timers=new WeakMap();
 function cancel(item){var t=timers.get(item);if(t){clearTimeout(t);timers.delete(item);}}
 function close(item){cancel(item);item.classList.remove('is-open');var btn=item.querySelector('.lolly-mega-item__arrow');if(btn)btn.setAttribute('aria-expanded','false');}
 function closeAll(except){items.forEach(function(i){if(i!==except)close(i);});}
 function open(item){if(document.documentElement.classList.contains('lolly-scrolled'))return;cancel(item);closeAll(item);item.classList.add('is-open');var btn=item.querySelector('.lolly-mega-item__arrow');if(btn)btn.setAttribute('aria-expanded','true');}
 items.forEach(function(item){
   var btn=item.querySelector('.lolly-mega-item__arrow');if(!btn)return;
   item.addEventListener('pointerenter',function(e){
      if(e.pointerType!=='mouse')return;cancel(item);
      timers.set(item,setTimeout(function(){open(item);},340));
   });
   item.addEventListener('pointerleave',function(e){if(e.pointerType!=='mouse')return;cancel(item);timers.set(item,setTimeout(function(){if(!item.contains(document.activeElement))close(item);},220));});
   btn.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();item.classList.contains('is-open')?close(item):open(item);});
   item.addEventListener('keydown',function(e){if(e.key==='Escape'){close(item);btn.focus();}});
   item.addEventListener('focusout',function(e){if(e.relatedTarget&&!item.contains(e.relatedTarget))close(item);});
 });
 document.addEventListener('pointerdown',function(e){if(!root.contains(e.target))closeAll();});
 document.addEventListener('keydown',function(e){if(e.key==='Escape')closeAll();});
 window.addEventListener('scroll',function(){if(document.documentElement.classList.contains('lolly-scrolled'))closeAll();},{passive:true});
})();
